var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dialogImageUrlVisible)?_c('el-image',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"elImage",attrs:{"src":_vm.dialogImageUrl,"preview-src-list":[_vm.dialogImageUrl],"fit":"contain"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.handlePreviewClose()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }